import styled from 'styled-components';

const Container = styled.div`
  max-width: 600px;
  padding: 12px;
  width: 80vw;
`;

const Heading = styled.div`
  font-size: 16px;
  text-align: center;
  margin: 32px 0;
`;

const BasicOrder = styled.div`
  text-align: center;
  padding: 12px;
  max-width: 438px;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 20px 20px 40px #d9d9d9, -20px -20px 25px #fff;
  align-items: center;
  transition: all ease-out 0.25s;
  cursor: pointer;
  margin-bottom: 30px;
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 5px 0 10px;
  }

  p {
    font-size: 15px;
    margin-top: 0;
  }
`;

const CreateOrderButton = styled.div`
  button {
    background-image: linear-gradient(90deg, white 50%, transparent 50%),
      linear-gradient(90deg, white 50%, transparent 50%),
      linear-gradient(0deg, white 50%, transparent 50%),
      linear-gradient(0deg, white 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
    background-position: left top, right bottom, left bottom, right top;
    animation: border-dance 1s infinite linear;
    background-color: #000;
    width: 300px;
    color: #fff;
    font-weight: bold;
    font-size: 19px;
    box-shadow: none;
    padding: 0;
    @keyframes border-dance {
      0% {
        background-position: left top, right bottom, left bottom, right top;
      }
      100% {
        background-position: left 15px top, right 15px bottom, left bottom 15px,
          right top 15px;
      }
    }
    :hover {
      background-color: #000;
    }
  }
`;
export { Heading, Container, BasicOrder, CreateOrderButton };
